(function() {
    'use strict';
    angular
        .module('bozorakaAdminApp')
        .factory('TicketPayment', TicketPayment);

    TicketPayment.$inject = ['$resource', 'DateUtils'];

    function TicketPayment ($resource, DateUtils) {
        var resourceUrl =  'api/ticket-payments/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.departureDate = DateUtils.convertDateTimeFromServer(data.departureDate);
                        data.createdDate = DateUtils.convertDateTimeFromServer(data.createdDate);
                        data.lastModifiedDate = DateUtils.convertDateTimeFromServer(data.lastModifiedDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'queryFromMySafar': { url: 'api/ticket-payments/my-safar', method: 'GET' }
        });
    }
})();
